import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import VueTheMask from 'vue-the-mask'
import VueTelInput from 'vue-tel-input'

Vue.use(VueTelInput) // Define default global options here (optional)
Vue.use(VueTheMask)

Vue.prototype.OneSignal = window.OneSignal || [];
//Object.definePrototype(Vue.prototype, 'OneSignal', { value: window.OneSignal });

Vue.config.productionTip = false



Vue.use(VueAxios, axios);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
